import $ from 'jquery';
import  fancybox  from './jquery.fancybox.min';

// FancyBox

function fancyBox() {
    
     $('[data-fancybox]').fancybox({
        baseClass: "custom-gallery",
        //transitionEffect: "slide",
        //transitionEffect: "fade",
        animationEffect: "fade",
        infobar: false,
        margin: 0,
        hash : false,
        transitionEffect: "fade",
        transitionDuration: 500,
        animationDuration: 500,
        touch: {
          vertical: false
        },
        image: {
            // Wait for images to load before displaying
            //   true  - wait for image to load and then display;
            //   false - display thumbnail and load the full-sized image over top,
            //           requires predefined image dimensions (`data-width` and `data-height` attributes)
            preload: false
          },
        buttons: [
            //"zoom",
            //"share",
            //"slideShow",
            //"fullScreen",
            //"download",
            //"thumbs",
            //"close"
        ],
        // caption : function( instance, item ) {
        //     return $(this).find('figcaption').html(); 
        // },
        /* thumbs : {
            autoStart : true,
            parentEl: ".fancybox-caption", 
            axis      : 'x'
        }, */
        
        
        baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1">'+
            '<div class="fancybox-bg"></div>'+
            '<div class="fancybox-inner">'+
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>'+
            '<div class="fancybox-stage"></div>'+
            '<div class="fancybox-controlbox"><div class="fancybox-caption"><div class="fancybox-caption__body"></div><div class="fancybox-toolbar">{{buttons}}</div></div></div>'+
            '</div>'+
            '</div>',
            
        // btnTpl: {
        //         download:
        //           '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><span class="underline show">{{DOWNLOAD}}</span>' +
        //           '<svg aria-labelledby="Download1" viewBox="0 0 471.2 471.2"><g xmlns="http://www.w3.org/2000/svg"><path d="M453.258 230.259c-7.35 0-13.23 5.88-13.23 13.23v120.344c0 32.732-26.656 59.29-59.29 59.29H90.462c-32.732 0-59.29-26.656-59.29-59.29V241.529c0-7.35-5.88-13.23-13.23-13.23s-13.23 5.88-13.23 13.23v122.304c0 47.334 38.514 85.75 85.75 85.75h290.276c47.334 0 85.75-38.514 85.75-85.75V243.489c0-7.252-5.88-13.23-13.23-13.23z" data-original="#000000"/><path d="M226.29 344.527c2.548 2.548 5.978 3.92 9.31 3.92s6.762-1.274 9.31-3.92l84.084-84.084a13.19 13.19 0 000-18.718 13.19 13.19 0 00-18.718 0l-61.446 61.544V34.847c0-7.35-5.88-13.23-13.23-13.23s-13.23 5.88-13.23 13.23v268.422l-61.544-61.544a13.19 13.19 0 00-18.718 0 13.19 13.19 0 000 18.718l84.182 84.084z" class="extranal-download-arrow" data-original="#000000"/></g></svg>' +
        //           "</a>",
        // },
        // lang: "it",
        // i18n: {
        //     en: {
        //         DOWNLOAD: "Download",
        //     },
        //     de: {
        //         DOWNLOAD: "Herunterladen",
        //     },
        //     it: {
        //         DOWNLOAD: "Bild herunterladen",
        //     }
        // },
        // initLayout: function(instance) {
        //     var $rightCol = $('<div class="fancybox__rightCol">' +
        //     '<div class="wrap">' +
        //     '<div class="logo"><a href="index.html"><img src="https://peakmedia.svr.fm/wp-content/uploads/2022/04/logo.svg" alt="Logo"></a>' +
        //     '<button class="carousel__button is-close" title="Close" tabindex="0">' +
        //     '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1">' +
        //     '<path d="M20 20L4 4m16 0L4 20"></path></svg></button></div></div></div>');
      
        //   instance.$refs.container.prepend($rightCol);
        // },
        onInit: function( instance, fancyBox ) {
            const anchor_href = $("#logo").attr("href");
            const logo_path = $("#logo > img").attr("src")
			var $rightCol = $('<div class="fancybox__rightCol">' +
            '<div class="wrap">' +
            `<div class="logo"><a href="${anchor_href}"><img src="${logo_path}" alt="Logo"></a>` +
            '<button data-fancybox-close class="carousel__button is-close" title="Close" tabindex="0">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg></button></div></div></div>');
      
          instance.$refs.container.prepend($rightCol);

        //   const $rightCol = document.createElement("div");
        //             // console.log(dataLogo);
        //             $rightCol.classList.add("fancybox__rightCol");
        //             $rightCol.innerHTML = '<div class="wrap"><div class="logo"><a href="index.html"><img src="https://peakmedia.svr.fm/wp-content/uploads/2022/04/logo.svg" alt="Logo"></a><button data-fancybox-close class="fancybox-button fancybox-button--close" title="Close" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg></button></div></div>';
                    
        //             instance.$refs.container.prepend($rightCol);

		},	
        // caption : function( instance, item ) {
        //     var hrefLink = $(this).data('href') || '';
            
        //     return ( hrefLink.length ? hrefLink + '<br />' : '' ) + '<a href="' + item.hrefLink + '"></a>' ;
        // }		
        caption: function(instance, item) {
           // return '<a href="' + $(item.opts.$orig).data('href') + '">' + $(item.opts.$orig).data('caption') + '</a>';
           
           let caption = $(item.opts.$orig).data('caption') != undefined ? $(item.opts.$orig).data('caption') : "";
           
            // Check if the anchor tag has a valid href attribute
            var hrefValue = $(item.opts.$orig).data('href');
            if (hrefValue && hrefValue.trim() !== '') {
                // If the href attribute is not empty or undefined, create the <a> tag with the link
                return '<a href="' + hrefValue + '">' + caption + '</a>';
            } else {
                // If the href attribute is empty or undefined, create a <span> element with the caption text
                // return '<span>' + $(item.opts.$orig).data('caption') + '</span>';
                return '<span>' + caption + '</span>';
            }

        }	
        // onInit: function(instance) {
        //     /* #1 Create bullet navigation links
        //     =================================*/
        //     //console.log(instance.$refs.container);
        //     var bullets = '<ul class="quick-view-bullets">';
        //     for (var i = 0; i < instance.group.length; i++) {
        //         bullets += '<li><a data-index="' + i + '" href="javascript:;"><span>' + (i + 1) + "</span></a></li>";
        //     }
        //     bullets += "</ul>";
        //     $(bullets).on("click touchstart", "a", function() {
        //         var index = $(this).data("index");
        //             $.fancybox.getInstance(function() {
        //                 this.jumpTo(index);
        //             });
        //     }).insertBefore(instance.$refs.container.find(".fancybox-navigation"));
        // },
        // beforeShow: function(instance) { 
        //     /* Mark current bullet navigation link as active */
        //     instance.$refs.container
        //       .find(".quick-view-bullets")
        //       .children()
        //       .removeClass("active")
        //       .eq(instance.currIndex)
        //       .addClass("active");
        // }	
    });



    $('[data-fancybox^="gallery"]').fancybox({
        baseClass: "custom-gallery",
        //transitionEffect: "slide",
        //transitionEffect: "fade",
        animationEffect: "fade",
        infobar: false,
        margin: 0,
        hash : false,
        transitionEffect: "fade",
        transitionDuration: 500,
        animationDuration: 500,
        loop: true,

        touch: {
          vertical: false
        },
        image: {
            // Wait for images to load before displaying
            //   true  - wait for image to load and then display;
            //   false - display thumbnail and load the full-sized image over top,
            //           requires predefined image dimensions (`data-width` and `data-height` attributes)
            preload: false
          },
        buttons: [
            //"zoom",
            //"share",
            //"slideShow",
            //"fullScreen",
            //"download",
            //"thumbs",
            //"close"
        ],
        // caption : function( instance, item ) {
        //     return $(this).find('figcaption').html(); 
        // },
        /* thumbs : {
            autoStart : true,
            parentEl: ".fancybox-caption", 
            axis      : 'x'
        }, */
        
        
        baseTpl:
            '<div class="fancybox-container" role="dialog" tabindex="-1">'+
            '<div class="fancybox-bg"></div>'+
            '<div class="fancybox-inner">'+
            '<div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div>'+
            '<div class="fancybox-stage"></div>'+
            '<div class="fancybox-controlbox"><div class="fancybox-caption"><div class="fancybox-caption__body"></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fb-navbox"><div class="fancybox-navigation">{{arrows}}</div></div></div></div>'+
            '</div>'+
            '</div>',
            
        // btnTpl: {
        //         download:
        //           '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><span class="underline show">{{DOWNLOAD}}</span>' +
        //           '<svg aria-labelledby="Download1" viewBox="0 0 471.2 471.2"><g xmlns="http://www.w3.org/2000/svg"><path d="M453.258 230.259c-7.35 0-13.23 5.88-13.23 13.23v120.344c0 32.732-26.656 59.29-59.29 59.29H90.462c-32.732 0-59.29-26.656-59.29-59.29V241.529c0-7.35-5.88-13.23-13.23-13.23s-13.23 5.88-13.23 13.23v122.304c0 47.334 38.514 85.75 85.75 85.75h290.276c47.334 0 85.75-38.514 85.75-85.75V243.489c0-7.252-5.88-13.23-13.23-13.23z" data-original="#000000"/><path d="M226.29 344.527c2.548 2.548 5.978 3.92 9.31 3.92s6.762-1.274 9.31-3.92l84.084-84.084a13.19 13.19 0 000-18.718 13.19 13.19 0 00-18.718 0l-61.446 61.544V34.847c0-7.35-5.88-13.23-13.23-13.23s-13.23 5.88-13.23 13.23v268.422l-61.544-61.544a13.19 13.19 0 00-18.718 0 13.19 13.19 0 000 18.718l84.182 84.084z" class="extranal-download-arrow" data-original="#000000"/></g></svg>' +
        //           "</a>",
        // },
        // lang: "it",
        // i18n: {
        //     en: {
        //         DOWNLOAD: "Download",
        //     },
        //     de: {
        //         DOWNLOAD: "Herunterladen",
        //     },
        //     it: {
        //         DOWNLOAD: "Bild herunterladen",
        //     }
        // },
        // initLayout: function(instance) {
        //     var $rightCol = $('<div class="fancybox__rightCol">' +
        //     '<div class="wrap">' +
        //     '<div class="logo"><a href="index.html"><img src="https://peakmedia.svr.fm/wp-content/uploads/2022/04/logo.svg" alt="Logo"></a>' +
        //     '<button class="carousel__button is-close" title="Close" tabindex="0">' +
        //     '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1">' +
        //     '<path d="M20 20L4 4m16 0L4 20"></path></svg></button></div></div></div>');
      
        //   instance.$refs.container.prepend($rightCol);
        // },
        onInit: function( instance, fancyBox ) {
            const anchor_href = $("#logo").attr("href");
            const logo_path = $("#logo > img").attr("src");

			var $rightCol = $('<div class="fancybox__rightCol">' +
            '<div class="wrap">' +
            `<div class="logo"><a href="${anchor_href}"><img src="${logo_path}" alt="Logo"></a>` +
            '<button data-fancybox-close class="carousel__button is-close" title="Close" tabindex="0">' +
            '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg></button></div></div></div>');
      
          instance.$refs.container.prepend($rightCol);

        //   const $rightCol = document.createElement("div");
        //             // console.log(dataLogo);
        //             $rightCol.classList.add("fancybox__rightCol");
        //             $rightCol.innerHTML = '<div class="wrap"><div class="logo"><a href="index.html"><img src="https://peakmedia.svr.fm/wp-content/uploads/2022/04/logo.svg" alt="Logo"></a><button data-fancybox-close class="fancybox-button fancybox-button--close" title="Close" tabindex="0"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"></path></svg></button></div></div>';
                    
        //             instance.$refs.container.prepend($rightCol);

		},	
        // caption : function( instance, item ) {
        //     var hrefLink = $(this).data('href') || '';
            
        //     return ( hrefLink.length ? hrefLink + '<br />' : '' ) + '<a href="' + item.hrefLink + '"></a>' ;
        // }		
        caption: function(instance, item) {
           // return '<a href="' + $(item.opts.$orig).data('href') + '">' + $(item.opts.$orig).data('caption') + '</a>';
           
           let caption = $(item.opts.$orig).data('caption') != undefined ? $(item.opts.$orig).data('caption') : "";
           
            // Check if the anchor tag has a valid href attribute
            var hrefValue = $(item.opts.$orig).data('href');
            if (hrefValue && hrefValue.trim() !== '') {
                // If the href attribute is not empty or undefined, create the <a> tag with the link
                return '<a href="' + hrefValue + '">' + caption + '</a>';
            } else {
                // If the href attribute is empty or undefined, create a <span> element with the caption text
                // return '<span>' + $(item.opts.$orig).data('caption') + '</span>';
                return '<span>' + caption + '</span>';
            }

        }	
        // onInit: function(instance) {
        //     /* #1 Create bullet navigation links
        //     =================================*/
        //     //console.log(instance.$refs.container);
        //     var bullets = '<ul class="quick-view-bullets">';
        //     for (var i = 0; i < instance.group.length; i++) {
        //         bullets += '<li><a data-index="' + i + '" href="javascript:;"><span>' + (i + 1) + "</span></a></li>";
        //     }
        //     bullets += "</ul>";
        //     $(bullets).on("click touchstart", "a", function() {
        //         var index = $(this).data("index");
        //             $.fancybox.getInstance(function() {
        //                 this.jumpTo(index);
        //             });
        //     }).insertBefore(instance.$refs.container.find(".fancybox-navigation"));
        // },
        // beforeShow: function(instance) { 
        //     /* Mark current bullet navigation link as active */
        //     instance.$refs.container
        //       .find(".quick-view-bullets")
        //       .children()
        //       .removeClass("active")
        //       .eq(instance.currIndex)
        //       .addClass("active");
        // }	
    });
    

}

export default fancyBox;